module.exports = __webpack_public_path__ + "img/b2.08423a3.png";